export const MILESTONE_STATUS_URL = '/api/loanPipelines/milestoneStatus';
